import { createAction, createSlice } from "@reduxjs/toolkit";

const portfolioSections = [ "mutualFunds", "stocks", "fno", "total"]
export const investmentsSlice = createSlice({
  name: "investments",
  initialState: {
    isLoading: true,
    error: null,
    investments: {
      mutualFunds:{},
      stocks:{},
      fno:{},
      total:{}
    },
  },
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setEmptyInvestmentsData: (state) => {
      portfolioSections.forEach((section)=>{
        state.investments[section].investment = 0;
        state.investments[section].margin = 0;
      })
      state.isLoading = false;
    },
    setInvestmentsData: (state, action) => {
      
      portfolioSections.forEach((section)=>{
        if(action.payload?.[section]?.hasError || !action.payload?.[section]){
          state.investments[section].hasError = true;
        } else {
          state.investments[section] = action.payload[section];
        }
      })      
      state.error = null;
      state.isLoading = false;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

// ACTIONS
export const setLoadingActionInv = createAction("investments/setLoading");
export const setEmptyInvestmentsDataAction = createAction("investments/setEmptyInvestmentsData");
export const setInvestmentsDataAction = createAction("investments/setInvestmentsData");
export const setErrorActionInv = createAction("investments/setError");

// REDUCERS
export default investmentsSlice.reducer;
